export const GetOfferData1 = [
	{
		month: 'may',
		monthDate: 'Мая'
	},
	{
		month: 'june',
		monthDate: 'Мая'
	},
	{
		month: 'july',
		monthDate: 'Мая'
	},
	{
		month: 'august',
		monthDate: 'Мая'
	},
	{
		month: 'september',
		monthDate: 'Мая'
	},
	{
		month: 'october',
		monthDate: 'Мая'
	},
	{
		month: 'november',
		monthDate: 'Мая'
	},
	{
		month: 'december',
		monthDate: 'Мая'
	},
	{
		month: 'january',
		monthDate: 'Мая'
	},
	{
		month: 'february',
		monthDate: 'Мая'
	},
	{
		month: 'mart',
		monthDate: 'Мая'
	},
	{
		month: 'april',
		monthDate: 'Мая'
	}
]
export const GetOfferData2 = [
	{
		monthDate: 'january_pad'
	},
	{
		monthDate: 'february_pad'
	},
	{
		monthDate: 'mart_pad'
	},
	{
		monthDate: 'april_pad'
	},
	{
		monthDate: 'may_pad'
	},
	{
		monthDate: 'june_pad'
	},
	{
		monthDate: 'july_pad'
	},
	{
		monthDate: 'august_pad'
	},
	{
		monthDate: 'september_pad'
	},
	{
		monthDate: 'october_pad'
	},
	{
		monthDate: 'november_pad'
	},
	{
		monthDate: 'december_pad'
	}
]
